import * as React from "react";
import {
  Typography,
  TextField,
  useMediaQuery,
  Button,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import Dropdown from "components/Dropdown/Dropdown";
import GenericSpinner from "components/GenericSpinner/GenericSpinner";
import { useSnackbar } from "notistack";
import { errorsType } from "./ConventionManagementTypes";
import axios from "axios";

interface ICommitteeCapacityModificationProps {
  committees: any[];
  header?: string;
  conventionId: number;
  errors: errorsType;
  onChangeForElements: any;
}

interface committeeType {
  committeeTypeId: number;
  committeeName: string;
  name?: string;
  value?: string;
}

const CommitteeCapacityModification: React.FunctionComponent<ICommitteeCapacityModificationProps> = (
  props
) => {
  const displayMobile = useMediaQuery("(max-width:959px)");

  const [selectedValueDropdown, setSelectedValueDropdown] = React.useState("");

  const { enqueueSnackbar } = useSnackbar();

  const [currentCapacity, setCurrentCapacity] = React.useState(0);

  const [requestPending, setRequestPending] = React.useState(false);

  // cancel request if need be
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  React.useEffect(() => {
    if (selectedValueDropdown !== "") {
      setRequestPending(true);
      axios
        .get(`/api/Committees/committeeCapacity/${selectedValueDropdown}`, {
          cancelToken: source.token,
        })
        .then((response: any) => {
          if (response) {
            setCurrentCapacity(response.data);
          }
          setRequestPending(false);
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.log("Error: " + error.message);
          } else {
            console.log(error);
            setRequestPending(false);
          }
        });
    }
    return () => {
      source.cancel("Committee capacity request cancelled.");
    };
  }, [selectedValueDropdown]);

  const committeesDropdownOnChange = (e: any) => {
    setSelectedValueDropdown(e.target.value);
  };

  const currentCapacityTextfieldOnChance = (e: any) => {
    props.onChangeForElements(e);
  };

  const updateCommitteeCapacityOnSubmit = (e: any) => {
    e.preventDefault();
    setRequestPending(true);
    axios
      .post(
        "/api/Committees/UpdateCommitteeCapacity",
        {
          CommitteeTypeId: selectedValueDropdown,
          NewCapacity: e.target.capacity.value,
          ConventionId: props.conventionId,
        },
        {
          cancelToken: source.token,
        }
      )
      .then((response) => {
        if (response && response.data) {
          const { data } = response;
          setCurrentCapacity(data.capacity);
          setRequestPending(false);
          enqueueSnackbar("convention capacity updated!", {
            variant: "success",
          });
        }
      });
  };

  return (
    <Grid container size={{ xs: 12 }}>
      {props.committees.length > 1 && (
        <Grid size={{ xs: 12 }}>
          <Typography variant="subtitle1">{props.header}</Typography>
        </Grid>
      )}
      <Grid container size={{ xs: 12 }} direction="row" justifyContent="flex-start" className="pt-3">
        {props.committees.length > 1 && (
          <Grid size={{ xs: 12, md: 3 }}>
            <Dropdown
              id={"convention-management-committees-dropdown"}
              label={"Committees"}
              selectedPropsValue={selectedValueDropdown}
              onChange={committeesDropdownOnChange}
              values={props.committees.map(
                (committee: committeeType, index: number) => {
                  let value = index === 0 ? "" : committee.committeeTypeId;
                  let placeholder = index === 0 ? "" : committee.committeeName;
                  return (
                    <option key={index} value={value}>
                      {placeholder}
                    </option>
                  );
                }
              )}
            />
          </Grid>
        )}
        <Grid
          size={{ xs: 12, md: 9 }}
          className={`${!displayMobile ? "pl-2" : "pl-0"}`}
        >
          <form
            onSubmit={updateCommitteeCapacityOnSubmit}
            method="post"
            className="w-100"
          >
            {requestPending ? (
              <Grid
                size={{ xs: 12, md: 2 }}
                className={`${displayMobile && "pt-3"}`}
              >
                <GenericSpinner includeOverlay={false} padding={0} />
              </Grid>
            ) : (
              <Grid container direction="row" justifyContent="flex-start">
                {selectedValueDropdown !== "" && (
                  <Grid
                    size={{ xs: 12, md: 4 }}
                    className={`${displayMobile && "pt-3"}`}
                  >
                    <TextField
                      fullWidth
                      label="Capacity"
                      required
                      onChange={currentCapacityTextfieldOnChance}
                      name="capacity"
                      defaultValue={currentCapacity}
                      variant="outlined"
                      error={props.errors.capacity.error}
                      helperText={
                        props.errors.capacity.error
                          ? "Enter a valid capacity. It should be a number"
                          : ""
                      }
                    />
                  </Grid>
                )}
                {selectedValueDropdown !== "" && (
                  <Grid
                    size={{ xs: 12, md: 8 }}
                    className={`${!displayMobile ? "pl-2 mt-2" : "pt-3"}`}
                  >
                    <Button
                      className={"btn"}
                      fullWidth={displayMobile ? true : false}
                      variant="contained"
                      type="submit"
                      size="large"
                      disabled={props.errors.capacity.error}
                    >
                      Update Capacity
                    </Button>
                  </Grid>
                )}
              </Grid>
            )}
          </form>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CommitteeCapacityModification;
